import { Theme } from "@mui/material";
import bgImage from "../../assets/bg/bg_main.png";
import { colors } from "../../theme/colors";

export const bodyContainer = ({ breakpoints }: Theme) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "95vh",
});

export const subContainer = ({ breakpoints }: Theme) => ({
  marginTop: "90px",
  height: "100%",
  width: { xs: "100%", sm: "500px" },
  borderRadius: { xs: "50px 50px 0 0", sm: "50px" },
  boxShadow: {
    sm: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);",
  },
});

export const bgContainer = ({ breakpoints }: Theme) => ({
  backgroundColor: colors.main,
  borderRadius: "50px 50px 0 0",
  backgroundImage: `url(${bgImage})`,
  backgroundRepeat: "repeat-x",
  height: "160px",
});

export const container = ({ breakpoints }: Theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});

export const itemText = ({ breakpoints }: Theme) => ({
  color: colors.main,
  fontWeight: "500",
  fontSize: 18,
  paddingBottom: 2,
});

export const searchContainer = ({ breakpoints }: Theme) => ({
  border: "1px #72B7BC solid",
  borderRadius: 3,
  width: "300px",
  height: "40px",
  mt: 8,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "0 10px",
  marginTop: "100px",
});

export const searchInput = ({ breakpoints }: Theme) => ({
  width: "100%",
  marginLeft: "10px",
});

export const startButton = ({ breakpoints }: Theme) => ({
  color: "white",
  backgroundColor: colors.light_black,
  margin: "50px 0",
  width: "190px",
  height: "50px",
  fontWeight: "500",
  fontSize: "18px",
  "&:hover": {
    backgroundColor: colors.light_black,
  },
});

export const tdItem = ({ breakpoints }: Theme) => ({
  maxWidth: 100,
  lineBreak: "anywhere",
  fontSize: "11px",
  // fontWeight: "bold",
  p: 0,
});

export const thItem = ({ breakpoints }: Theme) => ({
  fontSize: "11px",
  fontWeight: "bold",
  p: 0,
  minWidth: "70px",
});
